export default "__VITE_ASSET__r2O2PvHp__"